import * as actionTypes from "Redux/Actions/actionTypes";

const initialState = {
  jsonData: [],
  success: "",
  error: "",
};

const GettingStartedBranchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GETTINGSTARTED_BRANCH_RESPONSE:
      return {
        ...state,
        success: action.success,
        error: "",
        jsonData: action.success.data,
      };
    case actionTypes.GETTINGSTARTED_BRANCH_ERROR:
      return {
        ...state,
        error: action.error,
        success: "",
      };

    default:
      return state;
  }
};

export default GettingStartedBranchReducer;
